import React, { useEffect, useRef, useState } from 'react';
import './CustomDropdown.css';
import { FaCheck } from 'react-icons/fa';
import { plans } from '../../common/common';

const CustomDropdown = ({ setSelected, selected }) => {
  const [open, setOpen] = useState(false);
  // const [selected, setSelected] = useState(plans.find(p => p.selected));
  const dropdownRef = useRef(null);

  const handleSelect = (plan) => {
    setSelected(plan);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-header-chatgpt" onClick={() => setOpen(!open)}>
        {selected.title}
        <span className="arrow">&#9662;</span>
      </div>
      {open && (
        <div className="dropdown-menu-chatgpt">
          {plans.map(plan => (
            <div
              key={plan.id}
              className="dropdown-item-chatgpt"
              onClick={() => handleSelect(plan)}
            >
              <div className="item-text">
                <div style={{ display: "flex", alignItems: "center",marginBottom:"4px" }}>
                  <div className="item-title">{plan.title}</div>
                  {selected.id === plan.id && <FaCheck className="check-icon" />}
                </div>
                <div className="item-desc">{plan.description}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
